var chunkMapping = {
	"5": [
		16005
	],
	"67": [
		11067
	],
	"135": [
		32757
	],
	"451": [
		13451
	],
	"672": [
		77672
	],
	"709": [
		18810,
		55156,
		79917
	]
};
var idToExternalAndNameMapping = {
	"11067": [
		"default",
		"./useGetAppSettings",
		39968
	],
	"13451": [
		"default",
		"./helpers",
		39968
	],
	"16005": [
		"default",
		"./TableWrapper",
		39968
	],
	"18810": [
		"default",
		"./atoms",
		39968
	],
	"32757": [
		"default",
		"./useUpdateLoggedUser",
		39968
	],
	"55156": [
		"default",
		"./colors",
		39968
	],
	"77672": [
		"default",
		"./UploadWrapper",
		39968
	],
	"79917": [
		"default",
		"./main-client",
		39968
	]
};
__webpack_require__.f.remotes = (chunkId, promises) => {
	if(__webpack_require__.o(chunkMapping, chunkId)) {
		chunkMapping[chunkId].forEach((id) => {
			var getScope = __webpack_require__.R;
			if(!getScope) getScope = [];
			var data = idToExternalAndNameMapping[id];
			if(getScope.indexOf(data) >= 0) return;
			getScope.push(data);
			if(data.p) return promises.push(data.p);
			var onError = (error) => {
				if(!error) error = new Error("Container missing");
				if(typeof error.message === "string")
					error.message += '\nwhile loading "' + data[1] + '" from ' + data[2];
				__webpack_require__.m[id] = () => {
					throw error;
				}
				data.p = 0;
			};
			var handleFunction = (fn, arg1, arg2, d, next, first) => {
				try {
					var promise = fn(arg1, arg2);
					if(promise && promise.then) {
						var p = promise.then((result) => (next(result, d)), onError);
						if(first) promises.push(data.p = p); else return p;
					} else {
						return next(promise, d, first);
					}
				} catch(error) {
					onError(error);
				}
			}
			var onExternal = (external, _, first) => (external ? handleFunction(__webpack_require__.I, data[0], 0, external, onInitialized, first) : onError());
			var onInitialized = (_, external, first) => (handleFunction(external.get, data[1], getScope, 0, onFactory, first));
			var onFactory = (factory) => {
				data.p = 1;
				__webpack_require__.m[id] = (module) => {
					module.exports = factory();
				}
			};
			handleFunction(__webpack_require__, data[2], 0, 0, onExternal, 1);
		});
	}
}